import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { DECORATOR__data__do_not_populate_from_linked } from '../../_base/_decorators/DECORATOR__data__do_not_populate_from_linked';
import { DECORATOR__data__reset_if_not_linked } from '../../_base/_decorators/DECORATOR__data__reset_if_not_linked';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '../../_base/FIELD__base';
import { FIELD__ml_asset_lora } from '../../ml_asset/guidance_lora/FIELD__ml_asset_lora';
import { DECORATOR__class_serialization_tested } from '../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_is_input } from '../_base/DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from '../_base/DECORATOR__field_not_linked';
import { FIELD__list_base_generic } from './FIELD__list_base_generic';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__list_lora extends FIELD__list_base_generic<FIELD__ml_asset_lora> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_LIST__LORA;

  /*
   *  FIELDS META
   */

  field_connectable__value(graph: DTO_GRAPH__instance) {
    let total_weights = 0;

    for (let item of this.items) {
      if (!item.is_enabled.get_value()) continue;

      total_weights += item.weight.get_value();
    }

    let total_enabled_items = this.get_enabled_and_non_zero_weight_items().length;
    let total_items = this.items.length;

    return `${total_enabled_items}/${total_items} w:${total_weights}`;
  }

  /*
   *
   */

  sort_items(items: FIELD__ml_asset_lora[]) {
    items.sort(FIELD__ml_asset_lora.sort_by_hash);
  }

  /*
   *  METHODS
   */

  constructor() {
    super();

    this.item_connectable_type = ENUM__field_connectable_type.ML_ASSET__LORA;
  }

  @DECORATOR__data__reset_if_not_linked
  @DECORATOR__data__do_not_populate_from_linked
  post_init(): void {
    super.post_init();
  }

  protected override _create_item_internal__default() {
    return new FIELD__ml_asset_lora();
  }

  is_field_is_compatible_to_sync_with(other: FIELD__base) {
    if (!super.is_field_is_compatible_to_sync_with(other)) return false;

    return this.meta.node_family == other.meta.node_family;
  }

  get_enabled_and_non_zero_weight_items() {
    let out = [...this.items];

    out = out.filter(item => item.is_enabled.get_value());
    out = out.filter(item => item.weight.get_value() != 0);

    return out;
  }

  get_loras_by_hashes(hashes: string[]) {
    let out = [...this.items];

    out = out.filter(item => hashes.includes(item.model.get_value()));

    return out;
  }

  get_loras_by_hashes__except(hashes_exceptions: string[]) {
    let out = [...this.items];

    out = out.filter(item => !hashes_exceptions.includes(item.model.get_value()));

    return out;
  }

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    let enabled_and_non_zero_weight_items = this.get_enabled_and_non_zero_weight_items();

    if (enabled_and_non_zero_weight_items.is_empty()) return false;

    return super.has_effect_on_generation_runtime(graph);
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  find_item_from_list(item_to_compare: FIELD__ml_asset_lora) {
    return this.items.find_or_default(item => item.model.get_value() == item_to_compare.model.get_value(), FIELD__ml_asset_lora.CREATE_STUB());
  }

  /*
   *
   */
}
